export const SUBMIT_GENERAL_ERROR =
  'Payment method submission failed, you have not been charged. Please check your details and try again';
export const DISPLAY_GENERAL_ERROR =
  'Woops, something went wrong. Please contact support if this keeps happening';
